import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { colors } from '../styles/shared.js';
import { t } from '../i18n.js';

@customElement('nav-hints')
export class NavHints extends LitElement {
  static styles = [
    colors,
    css`
      :host {
        position: absolute;
        top: env(safe-area-inset-top, 12px);
        left: env(safe-area-inset-left, 12px);
        padding: 8px;
        pointer-events: none;
        font-size: 0.9rem;
        line-height: 1.4;
      }
      .hint {
        color: var(--color-dim);
      }
      .hint.disabled {
        opacity: 0.5;
      }
      kbd {
        color: #0f0;
        font-family: inherit;
      }
      .disabled kbd {
        color: var(--color-dim);
        opacity: 0.5;
      }
    `,
  ];

  @property({ type: Boolean }) accessor canGoPrev = false;
  @property({ type: Boolean }) accessor canGoNext = false;

  render() {
    return html`
      <div class="hint">${this._formatKeys(t('nav-save-exit'))}</div>
      <div class="hint ${this.canGoPrev ? '' : 'disabled'}">${this._formatKeys(t('nav-prev-level'))}</div>
      <div class="hint ${this.canGoNext ? '' : 'disabled'}">${this._formatKeys(t('nav-next-level'))}</div>
    `;
  }

  /** Replace [key] patterns with <kbd> elements */
  private _formatKeys(text: string) {
    const parts: (string | ReturnType<typeof html>)[] = [];
    let remaining = text;
    while (remaining.length > 0) {
      const start = remaining.indexOf('[');
      if (start === -1) {
        parts.push(remaining);
        break;
      }
      const end = remaining.indexOf(']', start);
      if (end === -1) {
        parts.push(remaining);
        break;
      }
      if (start > 0) parts.push(remaining.slice(0, start));
      const key = remaining.slice(start + 1, end);
      parts.push(html`<kbd>${key}</kbd>`);
      remaining = remaining.slice(end + 1);
    }
    return parts;
  }
}
